import { ChartPosition } from '/src/lib/types';

/**
 * Position
 */

export type PositionProps = ChartPosition;

export class Position implements PositionProps {
  x?: number;
  dx?: number;
  y?: number;
  dy?: number;
  transform?: string;

  constructor(x?: number, dx?: number, y?: number, dy?: number, transform?: string) {
    this.x = x;
    this.dx = dx;
    this.y = y;
    this.dy = dy;
    this.transform = transform;
  }
}
